<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="needs-validation"
>
  <app-new-manco-form-orderlines
    [customerNumber]="orderDetails.customerDetails.customerNo"
    [businessCustomer]="isBusinessCustomer"
    [orderlines]="orderlines"
    [originalLength]="orderDetails.orderlines.length"
  >
  </app-new-manco-form-orderlines>
  <div class="d-flex justify-content-between mt-3">
    <div class="d-flex flex-column w-50">
      <h3 class="text-center mb-3">Manco order gegevens</h3>
      <label
        class="form-label"
        for="mancoTypeSelect"
      >
        <strong>Reden opnieuw bestellen:</strong>
      </label>
      <select
        class="form-select form-select-sm"
        id="mancoTypeSelect"
        formControlName="mancoType"
        [formValidity]="form.get('mancoType')"
        [formValidityType]="'invalid'"
        [formValidityNeedsTouch]="false"
      >
        <option
          [value]="''"
          disabled
          hidden
        >
          Selecteer reden
        </option>
        <option
          *ngFor="let option of mancoTypeOptions"
          [value]="option.value"
        >
          {{ option.label }}
        </option>
      </select>

      <div
        *ngIf="form.get('mancoType')?.invalid"
        class="invalid-feedback"
      >
        Kies een geldige reden.
      </div>

      <ng-container *ngIf="!isPrivateCustomer">
        <label
          class="form-label mt-4"
          for="userUUIDSelect"
        >
          <strong>Manco op naam van:</strong>
        </label>
        <select
          class="form-select form-select-sm"
          id="userUUIDSelect"
          formControlName="userUUID"
          (change)="onUserChange()"
          [formValidity]="form.get('userUUID')"
          [formValidityType]="'invalid'"
          [formValidityNeedsTouch]="false"
        >
          <option
            [value]="''"
            disabled
            hidden
          >
            Selecteer gebruiker
          </option>
          <option
            *ngFor="let user of users"
            [value]="user.uuid"
          >
            {{ user.fullName }} ({{ user.loginEmailAddress }})
          </option>
        </select>
        <div
          *ngIf="!isUserPreselected && users.length > 0"
          class="text-warning mt-1"
        >
          De oorspronkelijke besteller kon niet automatisch worden bepaald. Kies handmatig een gebruiker.
        </div>
        <div
          *ngIf="!isUserPreselected && users.length === 0"
          class="text-danger mt-1"
        >
          Deze klant heeft geen geregistreerde gebruikers en de oorspronkelijke besteller is onbekend. Manco kan voor
          deze order niet via dit scherm worden aangemaakt.
        </div>
        <div
          *ngIf="form.get('userUUID')?.invalid"
          class="text-danger mt-1"
        >
          Selecteer een gebruiker.
        </div>
      </ng-container>
      <div
        *ngIf="isPrivateCustomer"
        class="d-flex flex-column mt-4"
      >
        <label class="form-label"><strong>Manco op naam van:</strong></label>
        <p class="mb-0">Manco wordt geboekt op klantnummer {{ orderDetails.customerDetails.customerNo }}.</p>
      </div>

      <div class="d-flex flex-column mt-4">
        <label
          class="form-label"
          for="customerRef"
          ><strong>Orderreferentie:</strong></label
        >
        <input
          id="customerRef"
          type="text"
          class="form-control form-control-sm"
          formControlName="customerRef"
        />
        <div
          *ngIf="form.get('forOrderNumber')?.errors?.['maxlength']"
          class="text-danger"
        >
          Order referentie mag maximaal 36 karakters zijn.
        </div>
      </div>
      <div class="d-flex flex-column mt-4">
        <strong>Notitie</strong>
        <textarea
          class="form-control"
          placeholder="Notitie aan/voor de Check-upper voor de follow-up"
          formControlName="note"
          rows="8"
          maxlength="255"
        ></textarea>
      </div>

      <div class="d-flex flex-column mt-4">
        <label
          class="form-label"
          for="fixedDeliveryDate"
        >
          <strong>Andere leverdatum:</strong>
        </label>
        <input
          id="fixedDeliveryDate"
          type="date"
          class="form-control form-control-sm"
          formControlName="fixedDeliveryDate"
          [min]="datePickerMin"
          [max]="datePickerMax"
          [formValidity]="form.get('fixedDeliveryDate')"
          [formValidityType]="'invalid'"
          [formValidityNeedsTouch]="false"
        />
        <div
          *ngIf="form.get('fixedDeliveryDate')?.invalid"
          class="text-danger"
        >
          Kies een leverdatum tussen vandaag en een jaar vooruit.
        </div>
      </div>

      <label
        class="form-label mt-4"
        for="followUpNeededSelect"
      >
        <strong>Opvolging:</strong>
      </label>
      <select
        class="form-select form-select-sm"
        id="followUpNeededSelect"
        formControlName="followUpNeeded"
        [formValidity]="form.get('followUpNeeded')"
        [formValidityType]="'invalid'"
        [formValidityNeedsTouch]="false"
      >
        <option
          [value]="''"
          disabled
          hidden
        >
          Selecteer opvolgingsoptie
        </option>
        <option
          *ngFor="let option of followUpNeededOptions"
          [value]="option.value"
        >
          {{ option.label }}
        </option>
      </select>

      <div
        *ngIf="form.get('followUpNeeded')?.invalid"
        class="invalid-feedback"
      >
        Kies een geldige opvolgingsoptie.
      </div>
    </div>
    <app-new-manco-form-deliveryaddress
      [shippingMethod]="orderDetails.shippingMethod"
      [form]="form"
      [addressOptions]="addressOptions"
      (addressSelectionChange)="onAddressSelectionChange($event)"
      class="w-50"
    ></app-new-manco-form-deliveryaddress>
  </div>
  <div class="d-flex h-100 mt-3">
    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="isFormValid()"
    >
      <i class="fa-regular fa-shopping-cart fa-l"></i> Manco aanmaken
    </button>
  </div>
</form>
